module.exports = __webpack_public_path__ + "img/gigalot-feedlot-solutions-logo.cb0e3501.svg";